module.exports = __webpack_public_path__ + "static/media/md-microphone.cba83723.svg";